import { arrowLeft, arrowRight } from "helper/icons";
export const MobilePagination = ({
  currentPage,
  totalPages,
  handlePageChange,
}) => {
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };
  return (
    <div className="fixed bottom-0 right-0 left-0 bg-white h-[60px] flex items-center px-6 justify-between">
      <button
        onClick={goToPreviousPage}
        className="flex flex-row items-center justify-center bg-white border border-gray-300 rounded-lg w-[36px] h-[36px] "
      >
        <img src={arrowLeft} alt="" />
      </button>
      <span>
        Page {currentPage} of {totalPages}{" "}
      </span>

      <button
        onClick={goToNextPage}
        className="flex flex-row items-center justify-center bg-white border border-gray-300 rounded-lg w-[36px] h-[36px]"
      >
        <img src={arrowRight} alt="" />
      </button>
    </div>
  );
};
